import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "云梅不智能", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_4 = {
  class: "percentage-label"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://yunmei.xypp.cc/pwa/"
}, "关于", -1);
import { Lock } from "../entity/Lock";
import { reactive } from 'vue';
import { unlockProcess } from '../utils/unlock.js';
import { useUserDataStore } from "@/store/userData";
export default {
  __name: 'startPage',
  setup(__props) {
    const userData = useUserDataStore();
    userData.init();
    let lockDataList = userData.lockList;
    const data = reactive({
      curLock: "",
      lockList: [],
      process: 0,
      text: "点击开锁按钮"
    });
    data.lockList = lockDataList.map(Lock.fromUrl);
    data.lockList = data.lockList.map(lock => ({
      value: lock.toString(),
      label: lock.label,
      key: lock.toString()
    }));
    data.curLock = (data.lockList[0] || {}).value;
    function processShow(pss, desc, errobj) {
      if (errobj) {
        pss = 0;
        desc = "出错了";
        if (errobj.toString() == "NotFoundError: Bluetooth adapter not available.") {
          desc = "未找到蓝牙适配器";
        } else if (errobj.toString() == "NotFoundError: User cancelled the requestDevice() chooser.") {
          desc = "您取消了选择";
        } else if (errobj.toString() == "NetworkError: Connection Error: Connection attempt failed.") {
          desc = "连接失败";
        }
        console.log(errobj.toString());
      }
      data.process = pss;
      data.text = desc;
    }
    return (_ctx, _cache) => {
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_ElButton = _resolveComponent("ElButton");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_col = _resolveComponent("el-col");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_badge, {
          value: "PWA",
          class: "item"
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        })]),
        _: 1
      }), _hoisted_2, _hoisted_3, _createVNode(_component_el_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_progress, {
          type: "dashboard",
          percentage: data.process
        }, {
          default: _withCtx(({}) => [_createElementVNode("span", _hoisted_4, _toDisplayString(data.text), 1)]),
          _: 1
        }, 8, ["percentage"])]),
        _: 1
      }), _hoisted_5, _hoisted_6, _createVNode(_component_el_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(" 使用 "), _createVNode(_component_el_select, {
          modelValue: data.curLock,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.curLock = $event),
          class: "m-2",
          size: "small"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.lockList, lock => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: lock.key,
              value: lock.value,
              label: lock.label
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"]), _createTextVNode(" 开门 ")]),
        _: 1
      }), _hoisted_7, _hoisted_8, _createVNode(_component_el_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_ElButton, {
          onClick: _cache[1] || (_cache[1] = $event => _unref(unlockProcess)(_unref(Lock).fromUrl(data.curLock), processShow)),
          size: "large",
          round: "",
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("开门 ")]),
          _: 1
        })]),
        _: 1
      }), _hoisted_9, _hoisted_10, _createVNode(_component_el_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: "/lockList"
          }, {
            default: _withCtx(() => [_createVNode(_component_ElButton, {
              circle: "",
              size: "large",
              type: "info"
            }, {
              default: _withCtx(() => [_createTextVNode("设置")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }), _createVNode(_component_el_col, {
          span: 6,
          style: {
            "text-align": "right"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: "/login"
          }, {
            default: _withCtx(() => [_createVNode(_component_ElButton, {
              circle: "",
              size: "large",
              type: "info"
            }, {
              default: _withCtx(() => [_createTextVNode("登录")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      })], 64);
    };
  }
};